import { Button, Input } from '@casumo/dojo-react';
import { memo } from 'react';
import { useRegistrationStore } from '../store/store.ts';
import { TDepositIncrementerField } from '../types/types.ts';

const DepositIncrementer = ({ name, label, options }: TDepositIncrementerField) => {
  const { formData, setFormData } = useRegistrationStore();

  const incrementDeposit = (amount: number) => {
    setFormData({
      [name]: (
        formData?.[name]
          ? +formData[name]! + amount
          : amount
      ).toString(),
    });
  };

  return (
    <div className="flex flex-col gap-sm">
      <div className="flex w-full gap-2xs">
        {options?.map((option) => (
          <Button onClick={() => incrementDeposit(+option.value)} className="w-full" key={option.value}>
            {option.label}
          </Button>
        ))}
      </div>
      <Input
        id="depositAmount"
        name="depositAmount"
        sufix="kr"
        type="number"
        value={formData?.depositAmount || ''}
        onChange={(e) => setFormData({ [name]: e.currentTarget.value })}
        label={label} />
    </div>
  );
};

const Memoized = memo(DepositIncrementer);
Memoized.displayName = 'DepositIncrementer';

export default Memoized;
